import React from "react"
import { Link } from "react-router-dom"

import { MNuArray } from "../../routes/menu"
import { classNames, getStandardRoute } from "../../utils/Helpers"

export const SideMenuMinified = ({ ActiveMNu }) => {
    return (
        <React.Fragment>
            <aside className="md:w-16 pt-14 hidden md:flex flex-col bg-inherit dark:bg-slate-900 text-gray-200 h-full z-10 p-1">
                <div className="w-full h-full bg-stone-200 dark:bg-slate-800 rounded-md">
                    <div className="w-full px-2 pb-1">
                        <ul className="flex flex-col rounded-md items-center h-full w-full space-y-3 overflow-auto pt-2 text-slate-600 text-sm">
                            {
                                MNuArray.map((zMNu: any) => {
                                    let DotMNu = zMNu.route.split('.')[0];
                                    let RouteMNu = undefined

                                    switch (DotMNu) {
                                        default:
                                            RouteMNu = getStandardRoute(zMNu.route)
                                            break;
                                    }

                                    return (
                                        <li key={`zMNu-${zMNu.code}-${zMNu.icon}`}>
                                            <Link to={RouteMNu} className={classNames(
                                                ActiveMNu === zMNu.code ? 'text-slate-800 bg-stone-300' : 'text-stone-700 dark:text-gray-200 hover:bg-gray-50/20',
                                                "h-10 w-10 flex items-center justify-center rounded-md"
                                            )} tabIndex={1} data-tooltip-target="tooltip-top" data-tooltip-placement="top">
                                                <div className="flex cursor-pointer items-center align-middle gap-x-4">
                                                    <span className={`fa-light ${zMNu.icon} fa-lg`}></span>
                                                </div>
                                            </Link>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </aside >
        </React.Fragment>
    )
}